import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-white whitespace-nowrap">
                韩漫网
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为中文用户提供最新、最全的韩国漫画在线阅读服务。每日更新，高清画质，流畅阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4 whitespace-nowrap">
              <strong>快速导航</strong>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4 whitespace-nowrap">
              <strong>热门分类</strong>
            </h4>
            <ul className="space-y-2">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4 whitespace-nowrap">
              <strong>联系方式</strong>
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@hanmanwang.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                <span>在线客服：9:00 - 22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; 2026 韩漫网 HanManWang.com - 韩国漫画在线阅读，最新免费漫画大全
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}